import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent {
  environment = environment;
  softwareName = environment.softwareName;

  constructor(private title: Title) {
    this.title.setTitle(`${environment.softwareName} - Informativa sulla Privacy`);
  }
}
